//161
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { RGBELoader } from 'three-stdlib';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  Buffer,
  PaintColorMaterial,
  WoodTopMaterial,
  WoodTopPaintColorMaterial,
} from '../../utils/materials';

//Multi-variant model
export function Charlotte_3_drawer_dresser(props) {
  const { variantName } = useContext(CurrentContext);

  return (
    <>
      {variantName === 'Painted Wood' && (
        <Charlotte_3_drawer_dresser_painted_wood />
      )}
      {variantName === 'Textured Silver' && (
        <Charlotte_3_drawer_dresser_textured_silver />
      )}
    </>
  );
}

export function Charlotte_3_drawer_dresser_textured_silver(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Charlotte 3 Drawer Dresser_silver.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-charlotte_3_drawer_dresser_silver-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopPaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    // 'ao-charlotte_3_drawer_dresser_wood-wood_top',
    // aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopMaterial,
    currentMaterialFinish.woodTopFinish,
    defaultFinish.woodTopFinish,
    // 'ao-charlotte_3_drawer_dresser_wood-wood_top',
    // aoIntensity,
  );

  const [hdriTexture, setHdriTexture] = useState(null);

  useEffect(() => {
    // Load the HDRI using RGBELoader
    new RGBELoader()
      .setPath('/hdri/') // Set the path to your HDRI folder
      .load('1.hdr', (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        setHdriTexture(texture);

        // Apply HDRI texture only to the Hardware_Style material
        if (materials.Hardware_Style) {
          materials.Hardware_Style.envMap = texture;
          materials.Hardware_Style.metalness = 1.0; // Fully metallic
          materials.Hardware_Style.roughness = 0.3;
          materials.Hardware_Style.needsUpdate = true; // Make sure the material updates
        }
      });
  }, [materials.Hardware_Style]);

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  if (!hdriTexture) {
    return null; // Return null while HDRI is loading
  }

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      {currentMaterialFinish?.woodTopFinish?.name === 'Painted' ? (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopPaintColorMaterial}
        />
      ) : (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopMaterial}
        />
      )}
      <mesh castShadow geometry={nodes.Buffer.geometry} material={Buffer} />
      <mesh
        castShadow
        r
        geometry={nodes.Screw.geometry}
        material={materials.Screw}
      />
      <mesh
        castShadow
        geometry={nodes.Hardware_Style.geometry}
        material={materials.Hardware_Style}
      />
      <Shadow model={'Charlotte 3 Drawer Dresser_silver'} />
    </group>
  );
}

export function Charlotte_3_drawer_dresser_painted_wood(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Charlotte 3 Drawer Dresser_wood.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-charlotte_3_drawer_dresser_wood-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopPaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-charlotte_3_drawer_dresser_wood-wood_top',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopMaterial,
    currentMaterialFinish.woodTopFinish,
    defaultFinish.woodTopFinish,
    'ao-charlotte_3_drawer_dresser_wood-wood_top',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      {currentMaterialFinish?.woodTopFinish?.name === 'Painted' ? (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopPaintColorMaterial}
        />
      ) : (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopMaterial}
        />
      )}
      <mesh castShadow geometry={nodes.Buffer.geometry} material={Buffer} />
      <mesh
        castShadow
        geometry={nodes.Screw.geometry}
        material={materials.Screw}
      />
      <Shadow model={'Charlotte 3 Drawer Dresser_wood'} />
    </group>
  );
}
